import DOMPurify from 'dompurify';
import React from 'react';

const camelToSnakeCase = (camelCaseString: string) =>
    camelCaseString.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);

const containsNumber = (s: string): boolean => {
    return /\d/.test(s);
};

const splitAtFirstSpace = (fullString: string) => {
    const i = fullString.indexOf(' ');
    return i > 0 ? [fullString.substring(0, i), fullString.substring(i + 1)] : [fullString];
};

const highlightAndSanitize = (
    textToHighlight: string,
    highlights: string[],
    style?: React.CSSProperties
): string => {
    // parsing style object to css string
    const highlightStyle = style
        ? Object.entries(style)
              .map(([k, v]) => `${camelToSnakeCase(k)}:${v}`)
              .join(';')
        : '';

    const regexes = highlights.map(
        (textToMakeBold) => new RegExp(`(?<!<)(${textToMakeBold})(?!>)`, 'gi')
    );

    let boldString = textToHighlight;
    for (let i = 0; i < highlights.length; i++) {
        boldString = boldString.replace(regexes[i], `<b style="${highlightStyle}">$1</b>`);
    }

    return DOMPurify.sanitize(boldString);
};

// very rough estimate of how similar two strings are
const calculateMatchScore = (condition: string, testee: string) => {
    const str1 = condition.toLowerCase();
    const str2 = testee.toLowerCase();

    if (str1 === str2) {
        return 100;
    } else if (str1.includes(str2)) {
        return (testee.length / condition.length) * 100;
    } else {
        return 0;
    }
};

const notSelectedLocal = (locale: string) => (locale === 'de' ? 'en' : 'de');

export {
    containsNumber,
    highlightAndSanitize,
    splitAtFirstSpace,
    calculateMatchScore,
    notSelectedLocal
};
